import { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router";
import apiInstance from "../../api/api";
import cameraIcon from "../../assets/images/camera-icon.svg";
import loadingGif from "../../assets/images/loading.gif";
import routeNames from "../../constants/routeNames";

import { errorHandler } from "../../helpers/errorHelper";
import Spinner from "../../components/common/spinner";
import closeXIcon from "../../assets/images/close-x-icon.svg";

export default function Scan() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [checkingUser, setCheckingUser] = useState(false);
  const [user, setUser] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const { setShowFooterImage } = useOutletContext();

  useEffect(() => {
    if (id) {
      setCheckingUser(true);
      apiInstance
        .checkUser(id)
        .then((response) => {
          if (!response?.result && response?.error) {
            errorHandler(response, navigate);
          } else if (response?.data) {
            setUser(response?.data);
            if (response?.data?.winner) {
              navigate(routeNames.CONFIRMATION, {
                state: {
                  redirected: true,
                },
              });
            }
          }
        })
        .finally(() => {
          setCheckingUser(false);
        });
    }
  }, [id]);

  const activateUser = async () => {
    setIsLoading(true);
    setShowFooterImage(false);
    setTimeout(() => {
      apiInstance
        .validate({
          _id: id,
          url: uploadedImage,
        })
        .then((response) => {
          if (response && response?.result) {
            navigate(routeNames.CONFIRMATION, {
              state: {
                redirected: true,
              },
            });
          } else if (!response?.result && response?.error) {
            errorHandler(response, navigate);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }, 6000);
  };

  const onFileUpload = (e) => {
    const file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async function () {
      const fileObject = {
        name: file.name,
        mimeType: file.type,
        fileContent: reader.result.split(",")[1],
      };
      setIsLoading(true);
      const response = await apiInstance.uploadImage(fileObject);
      if (response && response?.data) {
        setUploadedImage(response?.data);
      }
      setIsLoading(false);
    };
  };

  if (checkingUser) {
    return (
      <div className="card mx-auto w-full max-w-lg px-4 py-8 text-center">
        <Spinner size={32} color="text-green" />
      </div>
    );
  }

  if (uploadedImage) {
    return (
      <div
        className={`card mx-auto w-full max-w-lg ${
          !isLoading ? "px-4 py-8" : ""
        } text-center`}
      >
        <h1 hidden={isLoading} className="text-red mb-4 font-bold">
          {"Confirmation"}
        </h1>
        <p
          hidden={isLoading}
          className="text-red mx-auto max-w-xs text-center mb-4"
        >
          Your receipt has been successfully uploaded.
        </p>

        <img
          quality={100}
          src={loadingGif}
          priority="true"
          className="w-full py-8"
          alt="Burger King"
          hidden={!isLoading}
        />

        <div
          hidden={isLoading}
          className="border-8 max-w-[250px] border-white mx-auto w-full rounded-[12.5px] relative shadow-[0px_4px_4px_0px_#00000040]"
        >
          <div className="absolute top-1.5 right-1.5 rounded-full w-8 h-8 bg-red flex items-center justify-center">
            <img
              src={closeXIcon}
              className="w-3 h-3 cursor-pointer "
              onClick={() => {
                setUploadedImage(null);
              }}
              alt="close icon"
            />
          </div>
          <img
            src={uploadedImage}
            alt="Uploaded"
            className="max-w-[250px] w-full mx-auto  rounded-[4px]"
          />
        </div>

        <div hidden={isLoading} className="mx-auto !mt-10 text-center">
          <button onClick={activateUser} className="btn px-12">
            <span>Continue</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="card mx-auto w-full max-w-lg px-4 py-8 text-center">
      <h1 className="text-red mb-1 font-bold">{`Welcome back`}</h1>
      <h1 className="text-red mb-4 font-bold">{`${user?.firstName}`}</h1>

      <p className="text-red mx-auto max-w-xs text-center">
        Now you’ve purchased your Costa Express drink, please click the link
        below to upload a photo of your receipt to enter for a chance to win a
        daily prize.
      </p>

      <label
        className=" bg-accentRed flex items-center justify-center w-auto h-[250px] max-w-[250px] mx-auto p-10 rounded-[3px] mt-4 cursor-pointer"
        htmlFor="fileUpload"
      >
        <input
          type="file"
          name="fileUpload"
          id="fileUpload"
          hidden
          accept=".jpg,.jpeg,.png,.bmp"
          onChange={onFileUpload}
          disabled={isLoading}
        />
        <img
          quality={100}
          src={cameraIcon}
          priority="true"
          alt="Burger King"
          hidden={isLoading}
        />
        <div hidden={!isLoading}>
          <Spinner size={32} color="text-white" />
        </div>
      </label>

      <p className="text-red mx-auto max-w-xs text-center mt-4">
        When taking a photo of your receipt please ensure you have taken a clear
        photo to prove your purchase of a Costa Express drink during the
        promotional period. The line for the drink purchase and the date must be
        visible on the receipt.
      </p>

      <p className="text-red mx-auto max-w-xs text-center mt-4">
        If you don’t have your receipt, please refer to our{" "}
        <a href="/terms" target="_blank" className="underline">
          T&Cs
        </a>{" "}
        for ways to prove purchase.  
      </p>
    </div>
  );
}
